import * as preact from "preact";

export const charactersInLanguage = {
  es: "áéíóñúüªº¡¿",
  sv: "åäö",
  fr: "àâçèéêëîïôœùûüÿ",
  fi: "äö",
  nl: "éëó",
  da: "æøå",
  it: "àâèéêìíîïòôùû",
  de: "äöüß",
  ca: "àçèéíïòóúü",
  pl: "ąćęłńóśźż",
  pt: "àáâãçèéêìíïòóõùúüªº",
  sr: "абвгдђежзијклљмнњопрстћуфхцчџш",
  ru: "абвгдеёжзийклмнопрстуфхцчшщъыьэюя",
  ro: "ăâîşţ",
  cz: "áčďéěíňóřšťúůýž",
  el: "αβγδεζηθικλμνξοπρσςτυφχψωάέήίόύώϊϋΐΰ",
  tr: "çğıöşü",
  sl: "čšž",
  is: "áðéíóúýþæö",
  no: "æøå",
  sk: "áäčďéíĺľňóôŕšťúýž",
  hr: "ćčđšž",
  bg: "абвгдежзийклмнопрстуфхцчшщъьюя",
  ga: "áéíóú",
};

export const insertAtCaret = (
  textarea: HTMLTextAreaElement | undefined,
  text: string
) => {
  if (!textarea) {
    return;
  }

  const scrollPosition = textarea.scrollTop;
  const selectionStart = textarea.selectionStart ?? textarea.value.length;
  const selectionEnd = textarea.selectionEnd ?? selectionStart;
  const front = textarea.value.substring(0, selectionStart);
  const back = textarea.value.substring(selectionEnd);
  const nextPosition = selectionStart + text.length;

  textarea.value = front + text + back;
  textarea.selectionStart = nextPosition;
  textarea.selectionEnd = nextPosition;
  textarea.focus();
  textarea.scrollTop = scrollPosition;
  textarea.dispatchEvent(new Event("input", { bubbles: true }));
};

type Props = {
  inputElement?: HTMLTextAreaElement;
  getInputElement?: () => HTMLTextAreaElement | undefined;
  language: string;
  disabled?: boolean;
};

const AccentInputToolbar = ({
  inputElement,
  getInputElement,
  language,
  disabled = false,
}: Props) => {
  const characters = charactersInLanguage[language];
  const resolveInputElement = () =>
    getInputElement ? getInputElement() : inputElement;

  return (
    <div class="accentInputPanel">
      {characters
        ? characters.split("").map((character) => (
            <button
              key={character}
              disabled={disabled}
              onClick={() => insertAtCaret(resolveInputElement(), character)}
            >
              {character}
            </button>
          ))
        : null}
    </div>
  );
};

export default AccentInputToolbar;
